import type { PayList, ScaleEntry } from "../types";

export const trimScales = (score: number, scale?: PayList): { scale: ScaleEntry[]; factor: number } => {
    if (!scale) {
        return { scale: [{ pay: 0, perMetricPay: 0, metric: 0 }] as ScaleEntry[], factor: 1 };
    }
    const firstRepeat = scale.findIndex((element, index) => {
        return element.perMetricPay === scale[index + 1].perMetricPay;
    });
    const factor = Math.max(Math.ceil(score / firstRepeat), 1);
    const returnScale = scale.slice(0, firstRepeat * factor + 1);
    return { scale: returnScale, factor };
};
